const materials = 
{
  bricks: 
  {
    mainBrand : 'dolmen',
    brands:
    {
      dolmen:
      {
        items: ['mat-3001', 'mat-3003', 'mat-3005', 'mat-3007', 'mat-3009', 'mat-3011','mat-3002', 'mat-3004', 'mat-3006', 'mat-3008', 'mat-3010', 'mat-3012']        
      }
      // Otras marcas se añadirían aquí
    }
  },
  blocks: 
  {
    mainBrand : 'boonker',
    brands:
    {
      boonker:
      {
        items: ['mat-3013', 'mat-3014', 'mat-3015']        
      }
      // Otras marcas se añadirían aquí
    }
  }
  // Otros tipos se añadirían aquí
};

export default materials;